export default __webpack_public_path__ + "static/media/logo15096841.c3f1a5b4.png";